<template>
  <div class="dice-roller-plugin">
    <Suspense v-if="isDiceRollerVisible" :key="diceRollerKey">
      <template #default>
        <dice-roller-overlay />
      </template>
      <template #fallback>
        <div class="dice-overlay-loading">
          <q-spinner color="primary" size="3em" />
          <p>Loading dice roller...</p>
        </div>
      </template>
    </Suspense>

    <!-- Replace QPageSticky with a simple fixed positioned div -->
    <div v-if="showGlobalButton" class="dice-trigger-container">
      <q-btn
        round
        icon="casino"
        color="primary"
        @click="toggleDiceRoller"
        size="16px"
        padding="8px"
        class="dice-trigger-btn"
      />
    </div>
  </div>
</template>

<script>
  import { ref, computed, defineAsyncComponent, watch } from 'vue'
  import { useDiceRollerStore } from 'src/stores/diceRollerStore'

  // Lazy load the DiceRollerOverlay component
  const DiceRollerOverlay = defineAsyncComponent(() => import('./DiceRollerOverlay.vue'))

  export default {
    name: 'DiceRollerPlugin',

    components: {
      DiceRollerOverlay
    },

    props: {
      showGlobalButton: {
        type: Boolean,
        default: true
      }
    },

    setup() {
      const diceRollerStore = useDiceRollerStore()
      const isDiceRollerVisible = computed(() => diceRollerStore.isVisible)
      const diceRollerKey = ref(0)

      // Watch for opening the dice roller to update the key
      watch(isDiceRollerVisible, (visible, old) => {
        if (visible) {
          diceRollerKey.value++
        }
      })

      // Expose toggle method
      function toggleDiceRoller() {
        diceRollerStore.toggleDiceRoller()
      }

      return {
        toggleDiceRoller,
        isDiceRollerVisible,
        diceRollerKey
      }
    }
  }
</script>

<style lang="scss">
  .dice-roller-plugin {
    // Position container for dice button
    .dice-trigger-container {
      position: fixed;
      bottom: 18px;
      right: 72px;
      z-index: 3000; // Match AiChat FAB so AI panel (z=4000) overlays it
    }

    .dice-trigger-btn {
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
      transition: all 0.3s ease;

      &:hover {
        transform: rotate(20deg);
      }
    }

    .dice-overlay-loading {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      z-index: 5000;

      p {
        margin-top: 16px;
      }
    }
  }
</style>
